import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { actionCreators } from '../../store/SalesGoals';
import './SalesGoals.css';
import ReactSpeedometer from '../react-d3-speedometer/index';

class Home extends Component {
    constructor(props) {
        super(props);

        this.state = {
            maxValueTest: 550,
        }
    }

    componentWillMount() {
        // This method runs when the component is first added to the page
        this.props.queryGoals();
        this.props.history.push('/sales-goals');
    }

    componentWillReceiveProps(nextProps) {
        // This method runs when incoming props (e.g., route params) change
    }

    render() {
        return (
            <div>
                <h1>{this.props.noSalesGoalsFound === true ? 'Empire Paper Company' : 'Sales Goals'}</h1>
                <p className={this.props.noSalesGoalsFound === true ? '' : 'hidden'}>{this.props.noSalesGoalsText}</p>
                <div className={this.props.noSalesGoalsFound === true ? 'hidden' : ''}>
                    <h3>Sales Goal</h3>

                    <svg style={{ width: '0', height: '0', position: 'absolute' }} aria-hidden="true" focusable="false">
                        <linearGradient id="green-gradient" x2="1" y2="1">
                            <stop offset="0%" stopColor="#9CBF6E" />
                            <stop offset="50%" stopColor="darkgreen" />
                            <stop offset="100%" stopColor="darkgreen" />
                        </linearGradient>
                    </svg>

                    <ReactSpeedometer
                        value={this.props.salesActual}
                        ringWidth={30}
                        maxValue={this.props.salesGoalMaxValue}
                        segments={9}
                        goal={this.props.salesGoal}
                        height={200}
                        valueFormat={"~s"}
                        useCustomTicks={true}
                        useSecondNeedle={true}
                        secondNeedleValue={this.props.salesTracking}
                        needleTransitionDuration={500}
                        needleHeightRatio={0.9}
                        currentValueText={" "}
                        needleTransition="easeElastic"
                        forceRender={true}
                    />

                    <p className="goal-data">
                        Goal:<br /><span> ${this.props.salesGoal.toLocaleString(undefined, { maximumFractionDigits: 0 })}</span>
                        Sales:<br /><span style={{ color: "steelblue" }}> ${this.props.salesActual.toLocaleString(undefined, { maximumFractionDigits: 0 })}</span>
                        Tracking:<br /><span style={{ color: "darkgreen" }}> ${this.props.salesTracking.toLocaleString(undefined, { maximumFractionDigits: 0 })}</span>
                    </p>


                    <h3>Margin Goal</h3>
                    <ReactSpeedometer
                        value={this.props.gpActual}
                        ringWidth={30}
                        height={200}
                        goal={30}
                        useCustomTicks={true}
                        maxValue={50}
                        isMargin={true}
                        needleHeightRatio={0.9}
                        currentValueText={" "}
                        needleTransitionDuration={2000}
                        needleTransition="easeElastic"
                        forceRender={true}
                    />

                    <p className="goal-data">
                        Goal:<br /><span> 30.0%</span>
                        Margin:<br /><span style={{ color: "steelblue", fontWeight: "-700" }}> {this.props.gpActual.toFixed(1)}%</span>
                    </p>
                    <br /><br />

                    <h3 className="new-business-kpi-header">New Business Goal</h3>
                    <ReactSpeedometer
                        value={this.props.nbActual}
                        ringWidth={30}
                        height={200}
                        segments={9}
                        needleHeightRatio={0.9}
                        goal={this.props.nbGoal}
                        valueFormat={"~s"}
                        useCustomTicks={true}
                        useSecondNeedle={true}
                        currentValueText={" "}
                        secondNeedleValue={this.props.nbTracking}
                        maxValue={this.props.nbGoalMaxValue}
                        needleTransitionDuration={2000}
                        needleTransition="easeElastic"
                        forceRender={true}
                    />

                    <p className="goal-data">
                        Goal:<br /><span> ${this.props.nbGoal.toLocaleString(undefined, { maximumFractionDigits: 0 })}</span>
                        New Sales:<br /><span style={{ color: "steelblue" }}> ${this.props.nbActual.toLocaleString(undefined, { maximumFractionDigits: 0 })}</span>
                        Tracking:<br /><span style={{ color: "darkgreen" }}> ${this.props.nbTracking.toLocaleString(undefined, { maximumFractionDigits: 0 })}</span>
                    </p>
                </div>
            </div>
        );
    }

}

export default connect(
    state => state.home,
    dispatch => bindActionCreators(actionCreators, dispatch)
)(Home);



// WEBPACK FOOTER //
// ./src/components/sales/SalesGoals.js